import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type DoubleOptInPageStore } from '../store/doubleOptInPageStore'

export const DoubleOptInPageContext = createContext<DoubleOptInPageStore | null>(null)

export const useDoubleOptInPageContext = () => {
  const context = useContext(DoubleOptInPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with DoubleOptInPageContext')

  return context
}

type IProviderDoubleOptInPageProps = {
  value: DoubleOptInPageStore
  children: ReactNode
}

export const ProviderPageDoubleOptIn: FC<IProviderDoubleOptInPageProps> = ({ value, children }) => {
  return <DoubleOptInPageContext.Provider value={value}>{children}</DoubleOptInPageContext.Provider>
}
